import { statusChangeReasonsStateSelector } from '../../reducers/application-selectors';
import { createGenericDispatcher } from '../action-dispatcher-factory';

import * as Api from '../../api/api';

export const loadStatusChangeReasons = () =>
  createGenericDispatcher({
    name: 'STATUS_CHANGE_REASONS',
    loadFunction: () => Api.get('/application/statusreasons'),
    args: {},
    shouldExecuteSelector: statusChangeReasonsStateSelector,
  });
